import React from 'react';
import { Navigate } from 'react-router-dom';
import { useCustomerAuth } from '../contexts/CustomerAuthContext';
import { Loader2 } from 'lucide-react';

export const CustomerProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useCustomerAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <Loader2 className="w-8 h-8 text-emerald-500 animate-spin" />
      </div>
    );
  }

  if (!isAuthenticated) {
    // Preserve the intended destination so a shared event link opens directly
    // after login. We pass it BOTH as a `next` query param on /login (so the
    // redirect target is deterministic and independent of storage timing) and
    // as a localStorage fallback (so it survives the OTP + profile-setup hops).
    const target = window.location.pathname + window.location.search;
    if (target && target !== '/' && !target.startsWith('/login')) {
      localStorage.setItem('post_login_redirect', target);
      return <Navigate to={`/login?next=${encodeURIComponent(target)}`} replace />;
    }
    return <Navigate to="/login" replace />;
  }

  return children;
};
